module.exports = __webpack_public_path__ + "img/growcify-economical-pricing.f8795e21.png";